import axios from 'axios';

const backendUrl = process.env.VUE_APP_ADMIN_URL;

function headers() {
  const accessToken = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${accessToken}` };
}

export default class CompanyUsageService {
  static async getData(page, limit, search, type, fromDate, toDate, basis = 'active') {
    try {
      const params = { page, limit, type, basis };
      if (search) params.search = search;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      const response = await axios.get(`${backendUrl}/company-usage/data`, {
        params,
        headers: headers(),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getContractSuccess({
    page,
    limit,
    search,
    country,
    lineaNegocio,
    status,
    basis = 'active',
  }) {
    try {
      const params = { page, limit, basis };
      if (search) params.search = search;
      if (country) params.country = country;
      if (lineaNegocio) params.lineaNegocio = lineaNegocio;
      if (status) params.status = status;
      const response = await axios.get(`${backendUrl}/company-usage/contract-success`, {
        params,
        headers: headers(),
      });
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async updateUseGoal(contratoId, useGoal) {
    try {
      const response = await axios.patch(
        `${backendUrl}/company-usage/${contratoId}/use-goal`,
        { useGoal },
        { headers: headers() }
      );
      if (response.data.status === 'ok') return response.data;
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }
}
